module.exports = __webpack_public_path__ + "img/snow.2745c5a5.png";